import MGUtils from "@tp/h5utils";
import cookie from "js-cookie";
import { getQuery } from "./url";
import "@iptv/base-network";
import Api from "./api";

const baseNetwork = window.createBaseNetwork({
  platform: "web",
  baseURL: "",
  timeout: 10000,
});
const mgApiParse = (data) => {
  if (data === "") {
    return null;
  }

  if (typeof data === "string") {
    return JSON.parse(data);
  }

  return data;
};

export const login = (callback) => {
  MGUtils.allLogin().then(() => {
    callback && callback();
  });
};

export const logout = () => {
  cookie.remove("HDCN", {
    domain: ".mgtv.com",
  });
  cookie.remove("ticket", {
    domain: ".mgtv.com",
  });
};

/** mgtv 所有场景获取用户信息 */
const allGetUserInfo = async () => {
  return new Promise((resolve) => {
    /**设置超时时间 */
    const timer = setTimeout(() => {
      console.warn("获取用户信息超时");
      resolve(null);
    }, 5000);

    let ticket = getQuery("ticket") || "";
    if (ticket) {
      let params = {
        invoker: "mgst",
        ticket,
      };
      baseNetwork
        .jsonp(Api.getUserInfo, params)
        .then((data) => {
          if (!data.data) {
            throw new Error("未登录");
          }
          // // 获取 URL 参数中的 Cookie
          cookie.set("HDCN", data.data.data.ticket, {
            domain: ".mgtv.com",
          });
          cookie.set("ticket", data.data.data.ticket, {
            domain: ".mgtv.com",
          });
          cookie.set("uuid", data.data.data.uuid, {
            domain: ".mgtv.com",
          });
          resolve(mgApiParse(data.data.data));
          clearTimeout(timer);
        })
        .catch((error) => {
          console.log("未能获取用户登录信息:", error);
          clearTimeout(timer);
          resolve(null);
        });
      return;
    }

    MGUtils.allGetUserData()
      .then((data) => {
        if (!data) {
          throw new Error("未登录");
        }

        resolve(mgApiParse(data));
        clearTimeout(timer);
      })
      .catch((error) => {
        console.log("未能获取用户登录信息:", error);
        clearTimeout(timer);
        resolve(null);
      });
  });
};

/**
 * 获取用户信息
 * @returns Promise
 */
export const getUserInfo = async () => {
  let data = {};
  data = await allGetUserInfo();
  console.log("getUserInfo ~ data:", data);
  if (!data) {
    console.warn("获取用户登录信息失败");
    logout();
    return;
  }

  return {
    avatar: getAvatar(data.avatar),
    nickname: data.nickname,
    uuid: data.uuid,
    ticket: data.ticket,
    mobile: data.relate_mobile,
    avatarFrameType: data.avatarFrameType,
    vipinfo: data.vipinfo,
  };
};

/**
 * 获取用户头像
 * @param {String} avatar
 * 数据格式： avatar: "{"s":"https://ugc.hitv.com/xxx.gif","m":"https://ugc.hitv.com/xxx.gif","l":"https://ugc.hitv.com/xxx.gif","xl":"https://ugc.hitv.com/xxx.gif"}"
 * @returns
 */
const getAvatar = (avatar) => {
  let obj = {};
  if (typeof avatar === "string") {
    try {
      obj = JSON.parse(avatar);
    } catch (e) {
      obj = {};
    }
  } else {
    return avatar?.l || "";
  }

  return obj?.l || avatar || "";
};
